
<template>
<v-content>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Login to VSS</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-text-field prepend-icon="person" name="login" label="Login" type="text" v-model="email"></v-text-field>
              <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password" v-model="password"></v-text-field>
              <v-btn color="primary" type="submit">Login</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</v-content>
</template>

<script>
import jwt from 'jsonwebtoken'
import {
  unpackRules
} from '@casl/ability/extra'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      showSnackbar: false,
      duration: 4000
    }
  },
  methods: {
    goToSignin () {
      this.$router.push({
        name: 'AppSignup'
      })
    },
    login () {
      var loginObj = {
        username: this.email,
        password: this.password
      }
      this.$http.post(`/auth/login/`, loginObj)
        .then(response => {

          var decoded = jwt.decode(response.data.token.split(" ")[1]);
          localStorage.setItem('jwtToken', response.data.token)

          this.processRules(decoded.rules);

          this.$router.push({
            name: 'MainPage'
          })
        })
        .catch(e => {
          console.log(e);
          this.$root.$emit('snackbar', e.response.data.msg)
        })
    }
  }
}
</script>

<style>
.login-wrapper {
  width: 80%;
  height: 80%;
  margin: 15% auto;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
}

input:-webkit-autofill,
input:focus:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
}
</style>



// WEBPACK FOOTER //
// src/pages/AppLogin.vue